<template>
    <section class="userSteps">
        <div class="userSteps_header d-flex align-items-center align-items-center justify-content-between">
            <a href="javascript:void(0)" class="logo d-block"><img src="assets/images/logo.svg" alt="Logo"
                    title="ZuluTrade Web Application" /></a>
            <div class="rightBTN d-flex align-items-center justify-content-end">
                <a href="javascript:void(0)" class="d-flex align-items-center me-5 medium linkBtn"><img
                        src="assets/images/mobileApp.svg" alt="Icon" title="ZuluTrade App Download" class="me-2" />
                    Download
                    app</a>
                <a href="javascript:void(0)" class="medium linkBtn"> English</a>
            </div>
        </div>
        <div class="d-flex justify-content-end padSpace">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row">
            <div class="col-12">
                <router-link class="d-flex align-items-center backBtn medium" to="/trading-account">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> Back
                </router-link>
                <div class="counterStep text-end">
                    <p>2 out of 3</p>
                </div>
            </div>
            <div class="col-12 col-md-7">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">Do you have an existing <span class="bgTitle dark d-inline-block">Crypto exhange account?</span></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet justo dui. Proin et gravida lacus.</p>
                </div>
                <div class="card-body existingBroker d-flex align-items-center border-0 h-auto p-0">
                    <router-link to="/crypto-exhange-account1" class="grd_btn semibold me-3"> Yes </router-link>
                    <a href="javascript:void(0)" class="grd_btn semibold border-btn"> No, create one </a>
                </div>
            </div>
               
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    computed: {
        isActive() {
            return false
        }
    },
}
</script>